import ProspectDetailController from './prospect.detail.controller';

export default {
    template: require('./prospect.detail.html'),
    controller: ProspectDetailController
};
